import React from "react";
import { Link } from "react-router-dom";

import pohori_1 from "../../public/pohori_krkonose/pohori_1.png";
import pohori_2 from "../../public/pohori_krkonose/pohori_2.png";
import pohori_3 from "../../public/pohori_krkonose/pohori_3.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Krkonose = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={darkMode ? "pohori dark" : "pohori light"}>
        <div className="container">
          <div className="pohori-container">
            <div className="pohori-image">
              <img src={pohori_1} alt="" />
            </div>
            <div className="pohori-content">
              <h1 className={darkMode ? "dark-text" : "light-text"}>
                Krkonoše
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className={darkMode ? "pohori-trip dark" : "pohori-trip light"}>
        <div className="container">
          <div className="pohori-trip-container">
            <div className="pohori-trip-content">
              <h2 className={darkMode ? "dark-text" : "light-text"}>
                Kam se vydat v Krkonoších?
              </h2>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                Krkonoše jsou krásné, majestátní pohoří nacházející se na severu
                České republiky a na hranicích s Polskem. Je zde mnoho
                nádherných míst, která můžete objevovat a poznávat. Pro
                milovníky přírody Krkonoše nabízejí rozhsáhlé turistické trasy
                a přírodní rezervace.
              </p>
              <Link
                className={darkMode ? "dark-button-text" : ""}
                to="/krkonose/kamsevydat"
              >
                <span>Více</span>
              </Link>
            </div>
            <div className="pohori-trip-image">
              <img src={pohori_2} alt="" />
            </div>
          </div>
        </div>
      </section>

      <section
        className={darkMode ? "pohori-nature dark" : "pohori-nature light"}
      >
        <div className="container">
          <div className="pohori-nature-container">
            <div className="pohori-nature-image">
              <img src={pohori_3} alt="" />
            </div>
            <div className="pohori-nature-content">
              <h2 className={darkMode ? "dark-text" : "light-text"}>
                Příroda v Krkonoších
              </h2>
              <p
                className={darkMode ? "dark-second-text" : "light-second-text"}
              >
                CHKO Beskydy je svou rozlohou 1 160 km² největší chráněnou
                krajinnou oblastí v České republice. Naleznete zde původní
                pralesovité porosty, horské louky s výskytem vzácných
                karpatských rostlin a živočichů i unikátní pseudokrasové jevy.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Krkonose;
